import {createPortal} from "react-dom"
import {useEffect, useState} from "react"

type PageHeaderProps = {
    pageName: string
    pageDescription?: string
}

export default function PageHeader(
    {
        pageName,
        pageDescription
    }: PageHeaderProps
) {
    const [headerElement, setHeaderElement] = useState<HTMLElement | null>(null)

    useEffect(() => {
        setHeaderElement(() => document.querySelector("header"))
    }, [])

    if (!headerElement)
        return <></>

    headerElement.style.display = "block"

    return createPortal(<>
        <h1>{pageName}</h1>
        {pageDescription && <p>{pageDescription}</p>}
    </>, headerElement)
}
